/* eslint-disable */

const CSV = {
  parse(csv: string, reviver?: (row: number, column: number, value: string) => string) {
    reviver =
      reviver ||
      function (r, c, v) {
        return v;
      };
    let chars = csv.split(''),
      c = 0,
      cc = chars.length,
      start: number,
      end: number,
      table: string[][] = [],
      row: string[];
    while (c < cc) {
      table.push((row = []));
      while (c < cc && chars[c] !== '\r' && chars[c] !== '\n') {
        start = end = c;
        if (chars[c] === '"') {
          start = end = ++c;
          while (c < cc) {
            if (chars[c] === '"') {
              if (chars[c + 1] !== '"') {
                break;
              } else {
                chars[++c] = '';
              } // unescape ""
            }
            end = ++c;
          }
          if (chars[c] === '"') {
            ++c;
          }
          while (c < cc && chars[c] !== '\r' && chars[c] !== '\n' && chars[c] !== ',') {
            ++c;
          }
        } else {
          while (c < cc && chars[c] !== '\r' && chars[c] !== '\n' && chars[c] !== ',') {
            end = ++c;
          }
        }
        row.push(reviver(table.length - 1, row.length, chars.slice(start, end).join('')));
        if (chars[c] === ',') {
          ++c;
        }
      }
      if (chars[c] === '\r') {
        ++c;
      }
      if (chars[c] === '\n') {
        ++c;
      }
    }
    return table;
  },

  stringify(table: string[][], replacer: (r: number, c: number, v: string) => string) {
    replacer =
      replacer ||
      function (r, c, v) {
        return v;
      };
    let csv = '',
      c: number,
      cc: number,
      r: number,
      rr = table.length,
      cell: string;
    for (r = 0; r < rr; ++r) {
      if (r) {
        csv += '\r\n';
      }
      for (c = 0, cc = table[r].length; c < cc; ++c) {
        if (c) {
          csv += ',';
        }
        cell = replacer(r, c, table[r][c]);
        if (/[,\r\n"]/.test(cell)) {
          cell = `"${cell.replace(/"/g, '""')}"`;
        }
        csv += cell || (cell as unknown as number) === 0 ? cell : '';
      }
    }
    return csv;
  },
};

export default CSV;
